var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("div", { staticClass: "card" }, [
        _c("h3", [
          _vm._v(
            _vm._s(_vm.gradeName) + _vm._s(_vm.className) + "班知识点得分情况"
          ),
        ]),
        _c("div", { staticClass: "card-content" }, [
          _c(
            "div",
            { staticClass: "card-button" },
            [
              _c(
                "el-button-group",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "medium",
                        plain: !_vm.knowledgeActive,
                      },
                      on: {
                        click: function ($event) {
                          _vm.knowledgeActive = true
                        },
                      },
                    },
                    [_vm._v("图形")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "medium",
                        plain: _vm.knowledgeActive,
                      },
                      on: {
                        click: function ($event) {
                          _vm.knowledgeActive = false
                        },
                      },
                    },
                    [_vm._v("表格")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.examInfo.hasPaper == 2
            ? _c("div", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.knowledgeActive,
                        expression: "knowledgeActive",
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.knowledgeLoading,
                        expression: "knowledgeLoading",
                      },
                    ],
                    staticClass: "inner knowledge-point",
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "list" },
                      _vm._l(_vm.classKnowPointInfo, function (item, index) {
                        return _c("li", { key: index, staticClass: "item" }, [
                          _c("div", { staticClass: "knowledge-left" }, [
                            _c("span", [_vm._v(_vm._s(item.desc))]),
                            _c("label", [_vm._v(_vm._s(item.range))]),
                          ]),
                          _c("div", { staticClass: "knowledge-center" }, [
                            _c(
                              "ul",
                              { staticClass: "point-list" },
                              _vm._l(item.point, function (point, index) {
                                return _c("li", { key: "point-" + index }, [
                                  _vm._v(" " + _vm._s(point.pointName) + " "),
                                ])
                              }),
                              0
                            ),
                          ]),
                          _c("div", { staticClass: "knowledge-right" }, [
                            _vm._v(_vm._s(item.point.length || 0) + "个"),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.knowledgeActive,
                        expression: "!knowledgeActive",
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.knowledgeLoading,
                        expression: "knowledgeLoading",
                      },
                    ],
                    staticClass: "inner",
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.classKnowledgeStat,
                          size: "medium",
                          height: _vm.knowTableHeight,
                          border: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "objectName",
                            align: "center",
                            label: "知识点",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "weight",
                            width: "120px",
                            align: "center",
                            sortable: "",
                            label: "知识点权重",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "averageRate",
                            width: "120px",
                            align: "center",
                            sortable: "",
                            label: "平均得分率",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deviation",
                            width: "100px",
                            align: "center",
                            sortable: "",
                            label: "标准差",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "120px",
                            label: "对应题号",
                            "render-header": _vm.renderHeader,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("join-topic", {
                                      attrs: {
                                        texts: [
                                          scope.row.bigNum,
                                          scope.row.smallNum,
                                        ],
                                        nullText: scope.row.nums,
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2654877733
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "100px",
                            label: "知识点掌握",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        style: {
                                          color:
                                            _vm.levelStyles[
                                              scope.row.levelName
                                            ],
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.levelName))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3951125589
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "100px",
                            label: "班级对比",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "preview",
                                        on: {
                                          click: function ($event) {
                                            return _vm._compare(
                                              "KNOWLEDGE_POINT",
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("images/preview.png"),
                                            width: "18",
                                          },
                                        }),
                                        _c("span", [_vm._v("查看")]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3703996146
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm.examInfo.hasPaper == 0
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "no-data-msg" },
                  [
                    _c("div", [
                      _vm._v("无法关联知识点，请点击下方按钮上传试卷"),
                    ]),
                    !_vm.ifHistoryData
                      ? _c(
                          "el-upload",
                          {
                            attrs: {
                              headers: _vm.headers,
                              action: _vm.uploadUrl,
                              "show-file-list": false,
                              "on-success": _vm._handleQuestionUploadSuccess,
                              accept: ".doc,.docx",
                              "before-upload": _vm.beforeAction,
                              "on-error": _vm.handleError,
                            },
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "primary", size: "mini" } },
                              [_vm._v("上传试卷")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    height: "150px",
                    "padding-top": "70px",
                    color: "#999",
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("images/nodata.png"),
                      alt: "",
                      width: "100",
                    },
                  }),
                  _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
                    _vm._v("暂无数据"),
                  ]),
                ]
              ),
        ]),
      ]),
      _c("div", { staticClass: "card" }, [
        _c("h3", [
          _vm._v(
            _vm._s(_vm.gradeName) + _vm._s(_vm.className) + "班能力得分情况"
          ),
        ]),
        _c("div", { staticClass: "card-content" }, [
          _c(
            "div",
            { staticClass: "card-button" },
            [
              _c(
                "el-button-group",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "medium",
                        plain: !_vm.abilityActive,
                      },
                      on: {
                        click: function ($event) {
                          _vm.abilityActive = true
                        },
                      },
                    },
                    [_vm._v("图形")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "medium",
                        plain: _vm.abilityActive,
                      },
                      on: {
                        click: function ($event) {
                          _vm.abilityActive = false
                        },
                      },
                    },
                    [_vm._v("表格")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.classAbilityStat.length
            ? _c("div", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.abilityActive,
                        expression: "abilityActive",
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.abilityLoading,
                        expression: "abilityLoading",
                      },
                    ],
                    staticClass: "inner knowledge-point",
                  },
                  [
                    _vm.classAbilityStat.length > 0
                      ? _c("div", { attrs: { id: "abilityRadar" } })
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "center",
                              height: "150px",
                              "padding-top": "70px",
                              color: "#999",
                            },
                          },
                          [_vm._v(" 暂无数据 ")]
                        ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.abilityActive,
                        expression: "!abilityActive",
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.abilityLoading,
                        expression: "abilityLoading",
                      },
                    ],
                    staticClass: "inner",
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.classAbilityStat,
                          size: "medium",
                          height: _vm.abilityTableHeight,
                          border: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "objectName",
                            align: "center",
                            label: "能力",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "weight",
                            width: "120px",
                            align: "center",
                            sortable: "",
                            label: "能力权重",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "averageRate",
                            width: "120px",
                            align: "center",
                            sortable: "",
                            label: "平均得分率",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deviation",
                            width: "100px",
                            align: "center",
                            sortable: "",
                            label: "标准差",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "对应题号",
                            "render-header": _vm.renderHeader,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("join-topic", {
                                      attrs: {
                                        texts: [
                                          scope.row.bigNum,
                                          scope.row.smallNum,
                                        ],
                                        nullText: scope.row.nums,
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2654877733
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "100px",
                            label: "能力掌握",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        style: {
                                          color:
                                            _vm.levelStyles[
                                              scope.row.levelName
                                            ],
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.levelName))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3951125589
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "school_ranking",
                            width: "100px",
                            align: "center",
                            label: "班级对比",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "preview",
                                        on: {
                                          click: function ($event) {
                                            return _vm._compare(
                                              "QUESTION_ABILITY",
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("images/preview.png"),
                                            width: "18",
                                          },
                                        }),
                                        _c("span", [_vm._v("查看")]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            164935072
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    height: "150px",
                    "padding-top": "70px",
                    color: "#999",
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("images/nodata.png"),
                      alt: "",
                      width: "100",
                    },
                  }),
                  _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
                    _vm._v("暂无数据，请点击添加"),
                  ]),
                  !_vm.ifHistoryData
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small", round: "" },
                          on: { click: _vm._getPaper },
                        },
                        [_vm._v("添加")]
                      )
                    : _vm._e(),
                ],
                1
              ),
        ]),
      ]),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "580px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [_c("div", { attrs: { id: "compareBar" } })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }